import SearchResultList from './search-result-list';

export default SearchResultList;